export const scorecardKeys = {
	all: ["scorecard"] as const,
	categories: (organizationId: string) => [...scorecardKeys.all, "categories", organizationId] as const,
	fields: (organizationId: string) => [...scorecardKeys.all, "fields", organizationId] as const,
	candidate: (candidateId: string) => [...scorecardKeys.all, "candidate", candidateId] as const,
};
